import React from "react";
import styles from "./GetStarted.module.css";

const GetStartedControl = ({ width = 100, height = 100 }) => {
    return (
        <svg viewBox="0 0 72 72" width={width} height={height}>
            <path
                className={styles.cls1}
                d="M36.19,71.26c-19.49,0-35.34-15.85-35.34-35.34S16.71,0.58,36.19,0.58s35.34,15.85,35.34,35.34
	S55.68,71.26,36.19,71.26z M36.19,4.18c-17.5,0-31.74,14.24-31.74,31.74s14.24,31.74,31.74,31.74s31.74-14.24,31.74-31.74
	S53.69,4.18,36.19,4.18z"
            />
            <g>
                <g>
                    <g>
                        <g>
                            <path
                                className={styles.cls1}
                                d="M32.93,49.14c-0.17,0-0.33-0.06-0.46-0.19c-0.06-0.06-6.22-6.13-8.76-8.29c-3.1-2.63-3.79-4.89-3.92-6
					c-0.07-0.57,0.09-1.08,0.46-1.49c0.63-0.71,1.77-0.97,2.63-0.97c1.15,0,1.91,0.77,4.76,3.62l0.65,0.65
					c0.98,0.98,1.33,0.89,1.34,0.89c0.22-0.1,0.42-1.06,0.34-2.04l0-17.96c0-1.73,1.41-3.14,3.14-3.14c1.73,0,3.14,1.41,3.14,3.14
					v8.02c0,0.36-0.29,0.65-0.65,0.65c-0.36,0-0.65-0.29-0.65-0.65v-8.02c0-1.01-0.82-1.84-1.84-1.84c-1.01,0-1.84,0.82-1.84,1.84
					v17.91c0.05,0.59,0.12,2.71-1.1,3.27c-1.14,0.52-2.39-0.73-2.81-1.15l-0.65-0.65c-2.35-2.36-3.23-3.24-3.84-3.24
					c-0.59,0-1.34,0.18-1.65,0.53c-0.12,0.13-0.16,0.28-0.14,0.47c0.09,0.74,0.6,2.72,3.47,5.16c2.58,2.19,8.58,8.11,8.83,8.36
					c0.26,0.25,0.26,0.67,0.01,0.92C33.26,49.08,33.1,49.14,32.93,49.14z"
                            />
                            <path
                                className={styles.cls1}
                                d="M32.93,49.74c-0.33,0-0.64-0.13-0.88-0.36c-0.66-0.65-6.33-6.23-8.73-8.26c-3.26-2.77-3.99-5.19-4.13-6.38
					c-0.09-0.74,0.12-1.42,0.6-1.96c0.96-1.08,2.6-1.17,3.07-1.17c1.39,0,2.19,0.8,5.18,3.79l0.66,0.66
					c0.26,0.26,0.45,0.42,0.6,0.53c0.05-0.29,0.09-0.72,0.06-1.21l0-18.01c0-2.06,1.68-3.74,3.74-3.74c2.06,0,3.74,1.68,3.74,3.74
					v8.02c0,0.69-0.56,1.25-1.25,1.25s-1.25-0.56-1.25-1.25v-8.02c0-0.68-0.55-1.24-1.24-1.24c-0.68,0-1.24,0.55-1.24,1.24v17.91
					c0.06,0.67,0.13,3.09-1.45,3.82c-1.51,0.7-3-0.78-3.48-1.27l-0.65-0.65c-1.78-1.78-3.06-3.06-3.41-3.06
					c-0.52,0-1.07,0.17-1.2,0.33c0.09,0.67,0.57,2.48,3.27,4.77c2.5,2.12,8.21,7.75,8.86,8.38c0.5,0.49,0.51,1.29,0.02,1.78
					C33.58,49.61,33.27,49.74,32.93,49.74z M22.87,32.81c-0.69,0-1.68,0.2-2.18,0.76c-0.25,0.28-0.36,0.63-0.31,1.02
					c0.12,1.02,0.76,3.11,3.71,5.61c2.42,2.06,8.13,7.67,8.78,8.3l0.05,0.03c0.02,0,0.03-0.01,0.04-0.02
					c-0.65-0.71-6.33-6.31-8.8-8.4c-3.03-2.57-3.58-4.73-3.67-5.54c-0.04-0.36,0.05-0.68,0.28-0.94c0.51-0.58,1.56-0.73,2.1-0.73
					c0.85,0,1.64,0.79,4.25,3.4l0.66,0.66c0.91,0.91,1.62,1.26,2.13,1.03c0.74-0.34,0.82-1.84,0.75-2.68l0-17.96
					c0-1.34,1.09-2.44,2.44-2.44c1.34,0,2.44,1.09,2.44,2.44v8.02l0.1-8.02c0-1.4-1.14-2.54-2.54-2.54c-1.4,0-2.54,1.14-2.54,2.54
					l0,17.96l0,0c0,0,0.16,2.19-0.69,2.58l-0.14,0.05c-0.47,0.08-1.08-0.26-1.87-1.05l-0.65-0.65
					C24.37,33.41,23.74,32.81,22.87,32.81z"
                            />
                        </g>
                    </g>
                    <g>
                        <g>
                            <path
                                className={styles.cls1}
                                d="M35.59,29.88c-0.36,0-0.65-0.29-0.65-0.65v-3.84c0-1.73,1.41-3.14,3.14-3.14s3.14,1.41,3.14,3.14v2.18
					c0,0.36-0.29,0.65-0.65,0.65c-0.36,0-0.65-0.29-0.65-0.65v-2.18c0-1.01-0.82-1.84-1.84-1.84c-1.01,0-1.84,0.82-1.84,1.84v3.84
					C36.24,29.59,35.95,29.88,35.59,29.88z"
                            />
                            <path
                                className={styles.cls1}
                                d="M35.59,30.48c-0.69,0-1.25-0.56-1.25-1.25v-3.84c0-2.06,1.68-3.74,3.74-3.74s3.74,1.68,3.74,3.74v2.17
					c0,0.69-0.56,1.25-1.25,1.25c-0.69,0-1.25-0.56-1.25-1.25v-2.17c0-0.68-0.55-1.24-1.24-1.24c-0.68,0-1.24,0.55-1.24,1.24v3.84
					C36.84,29.92,36.28,30.48,35.59,30.48z M38.08,22.85c-1.4,0-2.54,1.14-2.54,2.54l0.05,3.89c0.03,0,0.05-0.02,0.05-0.05v-3.84
					c0-1.34,1.09-2.44,2.44-2.44c1.34,0,2.44,1.09,2.44,2.44v2.17l0.1-2.17C40.62,23.99,39.48,22.85,38.08,22.85z"
                            />
                        </g>
                    </g>
                    <g>
                        <g>
                            <path
                                className={styles.cls1}
                                d="M46.05,49.14c-0.07,0-0.15-0.01-0.22-0.04c-0.34-0.12-0.51-0.5-0.39-0.83c0.01-0.03,1.03-2.86,2.2-6.27
					c1.13-3.31,0.96-10.5,0.95-10.57c0-0.86-0.68-1.54-1.52-1.54c-0.83,0-1.51,0.67-1.52,1.49l0,0.04c0,0.36-0.29,0.65-0.65,0.65
					c0,0,0,0,0,0c-0.36,0-0.65-0.29-0.65-0.65c0-0.02,0-0.03,0-0.05l0.03-3.8c0-0.83-0.68-1.52-1.52-1.52s-1.52,0.68-1.52,1.52v1.67
					c0,0.36-0.29,0.65-0.65,0.65c-0.36,0-0.65-0.29-0.65-0.65v-1.67c0-1.56,1.27-2.83,2.83-2.83s2.83,1.27,2.83,2.83l-0.01,1.45
					c0.44-0.27,0.95-0.43,1.5-0.43c1.56,0,2.83,1.27,2.83,2.83c0.01,0.29,0.18,7.48-1.02,11.01c-1.17,3.42-2.19,6.27-2.2,6.29
					C46.56,48.98,46.31,49.14,46.05,49.14z"
                            />
                            <path
                                className={styles.cls1}
                                d="M46.05,49.74c-0.15,0-0.29-0.03-0.43-0.07c-0.31-0.11-0.56-0.34-0.71-0.64c-0.14-0.3-0.16-0.64-0.04-0.96
					c0.03-0.08,1.04-2.89,2.19-6.26c1.09-3.21,0.92-10.29,0.92-10.36c0-0.54-0.41-0.96-0.92-0.96c-0.5,0-0.91,0.41-0.92,0.9
					c-0.01,0.71-0.57,1.27-1.25,1.27c-0.69,0-1.25-0.56-1.25-1.25l0.03-3.85c0-0.5-0.41-0.91-0.92-0.91s-0.92,0.41-0.92,0.92v1.67
					c0,0.69-0.56,1.25-1.25,1.25c-0.69,0-1.25-0.56-1.25-1.25v-1.67c0-1.89,1.54-3.43,3.43-3.43s3.43,1.54,3.43,3.43l0,0.53
					c0.29-0.08,0.59-0.12,0.89-0.12c1.89,0,3.43,1.54,3.43,3.43c0.02,0.76,0.15,7.67-1.06,11.2c-1.18,3.47-2.2,6.29-2.21,6.31
					C47.05,49.41,46.57,49.74,46.05,49.74z M47.06,29.28c1.17,0,2.12,0.96,2.12,2.14c0,0.05,0.18,7.34-0.98,10.77
					c-1.17,3.41-2.2,6.27-2.2,6.29l0.05,0.06c0.01,0,0.04-0.01,0.05-0.03c0.03-0.08,1.05-2.9,2.2-6.29c1.16-3.4,1-10.5,0.99-10.8
					c0-1.24-1-2.24-2.23-2.24c-0.42,0-0.83,0.12-1.18,0.34l-0.93,0.58l0.02-2.55c0-1.22-1-2.22-2.23-2.22c-1.23,0-2.23,1-2.23,2.23
					v1.67l0.1-1.67c0-1.17,0.95-2.12,2.12-2.12s2.12,0.95,2.12,2.12l-0.03,3.8C44.96,30.22,45.91,29.28,47.06,29.28z"
                            />
                        </g>
                    </g>
                    <g>
                        <g>
                            <path
                                className={styles.cls1}
                                d="M47.77,55.78H30.18c-0.36,0-0.65-0.29-0.65-0.65v-6.63c0-0.36,0.29-0.65,0.65-0.65h17.59
					c0.36,0,0.65,0.29,0.65,0.65v6.63C48.43,55.48,48.13,55.78,47.77,55.78z M30.83,54.47h16.29v-5.33H30.83V54.47z"
                            />
                            <path
                                className={styles.cls1}
                                d="M47.77,56.37H30.18c-0.69,0-1.25-0.56-1.25-1.25v-6.63c0-0.69,0.56-1.25,1.25-1.25h17.59
					c0.69,0,1.25,0.56,1.25,1.25v6.63C49.02,55.81,48.46,56.37,47.77,56.37z M30.18,48.44l-0.05,6.68l17.65,0.05
					c0.03,0,0.05-0.02,0.05-0.05v-6.63L30.18,48.44z M47.72,55.07H30.23v-6.53h17.49V55.07z M31.43,53.87h15.09v-4.13H31.43V53.87z"
                            />
                        </g>
                    </g>
                </g>
            </g>
        </svg>
    );
};

export default GetStartedControl;
